const COUPON_TYPE_AMOUNT = 'amount';
const COUPON_TYPE_PERCENT = 'percent';
const COUPON_TYPE_NONE = 'none';

const COUPON_TYPE_FIXED_AMOUNT = 'fixed_amount';
const COUPON_TYPE_PERCENTAGE = 'percentage';

const COUPON_TYPE_MAP = {
    [COUPON_TYPE_AMOUNT]: COUPON_TYPE_FIXED_AMOUNT,
    [COUPON_TYPE_PERCENT]: COUPON_TYPE_PERCENTAGE
};

const getCouponObject = (coupon, currency) => {
    const discount = coupon && coupon.discount;
    const applied = Boolean(
        coupon &&
            coupon.eligible &&
            discount &&
            discount.type !== COUPON_TYPE_NONE &&
            discount.amount > 0
    );

    if (!applied) {
        return { coupon_applied: false };
    }

    return {
        coupon_applied: true,
        coupon_code: coupon.code,
        coupon_type: COUPON_TYPE_MAP[discount.type],
        coupon_discount_amount: discount.amount,
        coupon_discount_currency: currency
    };
};

module.exports = {
    getCouponObject
};
